import React, { useState, useEffect } from 'react';

const EntrepreneurCard = ({ entrepreneur, onClick }) => (
  <div className="entrepreneur-card" onClick={() => onClick(entrepreneur)}>
    <img src={entrepreneur.image} alt={entrepreneur.name} className="entrepreneur-image" />
    <div className="card-overlay">
      <h3>{entrepreneur.name}</h3>
      <p>{entrepreneur.company}</p>
    </div>
    <div className="category-tag">{entrepreneur.tags}</div>
  </div>
);

const EntrepreneurDetailPopup = ({ entrepreneur, onClose }) => (
  <div className="popup-overlay">
    <div className="popup-content">
      <button className="close-button" onClick={onClose}>&times;</button>
      <h2>{entrepreneur.name}</h2>
      <p>{entrepreneur.company}</p>
      <div className="book-list">
        {entrepreneur.books.map((book, index) => (
          <div key={index} className="book-item">
            <img src={book.cover_image} alt={book.book_title} />
            <h3>{book.book_title}</h3>
            <p>{book.book_author}</p>
            <a href={book.amazon_link} target="_blank" rel="noopener noreferrer">Buy on Amazon</a>
            <a href={book.audible_link} target="_blank" rel="noopener noreferrer">Listen on Audible</a>
          </div>
        ))}
      </div>
    </div>
  </div>
);

function App() {
  const [entrepreneurs, setEntrepreneurs] = useState([]);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [selectedEntrepreneur, setSelectedEntrepreneur] = useState(null);

  useEffect(() => {
    console.log('Fetching data...');
    fetch('/data/entrepreneurs.json')
      .then(response => {
        console.log('Response status:', response.status);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then(data => {
        console.log('Fetched data:', data);
        if (Array.isArray(data)) {
          setEntrepreneurs(data);
        } else {
          throw new Error('Invalid data format: expected an array');
        }
      })
      .catch(error => {
        console.error('Error fetching data:', error);
        setError(error.message);
        setEntrepreneurs([]);
      });
  }, []);

  const filteredEntrepreneurs = entrepreneurs.filter(entrepreneur => 
    entrepreneur.name.toLowerCase().includes(searchTerm.toLowerCase()) &&
    (selectedCategory === 'All' || entrepreneur.tags.includes(selectedCategory))
  );

  const categories = ['All', ...new Set(entrepreneurs.flatMap(e => e.tags.split(', ')))];

  return (
    <div className="App">
      <div className="hero-section">
        <img src="/images/logo.png" alt="EntrepreneurReads" className="logo-large" />
        <div className="search-bar">
          <input 
            type="text" 
            placeholder="Search entrepreneurs" 
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <select 
            value={selectedCategory} 
            onChange={(e) => setSelectedCategory(e.target.value)}
          >
            {categories.map(category => (
              <option key={category} value={category}>{category}</option>
            ))}
          </select>
        </div>
      </div>
      {error ? (
        <p>Error loading entrepreneurs: {error}</p>
      ) : entrepreneurs.length === 0 ? (
        <p>Loading entrepreneurs...</p>
      ) : (
        <div className="entrepreneur-grid">
          {filteredEntrepreneurs.map((entrepreneur) => (
            <EntrepreneurCard 
              key={entrepreneur.id} 
              entrepreneur={entrepreneur} 
              onClick={setSelectedEntrepreneur}
            />
          ))}
        </div>
      )}
      {selectedEntrepreneur && (
        <EntrepreneurDetailPopup 
          entrepreneur={selectedEntrepreneur} 
          onClose={() => setSelectedEntrepreneur(null)}
        />
      )}
    </div>
  );
}

export default App;
